/**
 * @generated SignedSource<<afc945b4f9a0f715f29c900b1aaa09f9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SettingsGeneralTab_account$data = {
  readonly id: string;
  readonly autoCloseDays: number | null;
  readonly slug: string | null;
  readonly ticketNumberNext: number | null;
  readonly responseSlaValue: number | null;
  readonly responseSlaUnit: string | null;
  readonly resolutionSlaValue: number | null;
  readonly resolutionSlaUnit: string | null;
  readonly " $fragmentType": "SettingsGeneralTab_account";
};
export type SettingsGeneralTab_account$key = {
  readonly " $data"?: SettingsGeneralTab_account$data;
  readonly " $fragmentSpreads": FragmentRefs<"SettingsGeneralTab_account">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SettingsGeneralTab_account",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "autoCloseDays",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ticketNumberNext",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "responseSlaValue",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "responseSlaUnit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "resolutionSlaValue",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "resolutionSlaUnit",
      "storageKey": null
    }
  ],
  "type": "TicketingAccount",
  "abstractKey": null
};

(node as any).hash = "f2aa904c8e9cd7e11d4d213a1632b172";

export default node;
